import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description?: string;
  ogImage?: string;
  ogType?: string;
  ogUrl?: string;
  isHome?: boolean;
}

export function SEO({
  title,
  description = "Trường học Phật giáo online - Phật pháp ứng dụng trong cuộc sống và công việc",
  ogImage,
  ogType = "website",
  ogUrl,
  isHome = false,
}: SEOProps) {
  // Nếu là trang home, sử dụng ảnh mặc định
  const defaultImage = "https://imagedelivery.net/meCI2KDHmnUhVs_SxNm-Og/bc531403-b03f-47ad-58ff-d280c84bd700/public";
  
  // Xây dựng URL OG image
  let imageUrl = isHome ? defaultImage : ogImage || defaultImage;
  
  // Kiểm tra pathname hiện tại
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  
  // Kiểm tra nếu đang ở trang khóa học
  const isCourse = pathname.includes('/courses/course-');
  
  // Xử lý placeholder cho trang khóa học
  if (isCourse) {
    // Nếu đang ở trang khóa học, luôn sử dụng OG động
    if (ogImage) {
      // Nếu có hình ảnh khóa học, dùng nó
      imageUrl = ogImage;
    } else {
      // Không có hình ảnh, dùng placeholder
      const origin = typeof window !== 'undefined' ? window.location.origin : 'https://giacngo.org';
      imageUrl = `${origin}/og-placeholder.png`;
    }
    
    // Cập nhật ogType cho trang khóa học
    ogType = "article";
  }
  
  const siteUrl = "https://giacngo.org";
  const currentUrl = typeof window !== 'undefined' ? window.location.href : ogUrl || siteUrl;

  return (
    <Helmet>
      <title>{isHome ? title : `${title} | Giác Ngộ`}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={isHome ? title : `${title} | Giác Ngộ`} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={isHome ? title : `${title} | Giác Ngộ`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
} 